export const PROP65_WARNING_LINK = 'www.P65Warnings.ca.gov';
